// extracted by mini-css-extract-plugin
export default {"cls1":"ol_5qsGpzqAp2vQ8_GhG","cls2":"Mpe7qlQg3tiO3EFhFA1T ol_5qsGpzqAp2vQ8_GhG"};